import ApiHandler from "./ApiHandler";

const Period = {
  findAll: async (query) => await ApiHandler.i.auth().get(`/period?${query.toString()}`),
  findOne: async (query) => await ApiHandler.i.auth().get(`/period/find?${query.toString()}`),
  getExists: async () => await ApiHandler.i.auth().get('/period/exist'),
  getOne: async (periodId) => await ApiHandler.i.auth().get(`/period/${periodId}`),
  postOne: async () => await ApiHandler.i.auth().post('/period', {}),
};

export default Period;